import { put, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { Notify } from '@flexisaf/flexibull2';
import {
  saveReminderSuccess,
  saveReminderFailed,
  editReminderSuccess,
  editReminderFailed,
  deleteReminderSuccess,
  deleteReminderFailed
} from '../actions';
import { ReminderTypes } from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

// save reminder

export function* saveReminderSettings({ payload: { data, cb } }) {
  const url = `${API_BASE_URL}/reminders`;

  const response = yield request({
    method: 'post',
    data,
    url,
  });
  if (response.success) {
    yield put(saveReminderSuccess(response.raw));
    cb();
    Notify('Reminder created successfully', {
      position: 'top-right',
      status: 'success',
    });
  } else {
    networkErrorHandler(response?.statusCode, `Failed to Save Reminder: ${response.message}`);
    yield put(saveReminderFailed(response.message));
  }
}

export function* savingReminderSettings() {
  yield takeEvery(ReminderTypes.SAVING_REMINDER_SETTINGS, saveReminderSettings);
}


// edit reminder
export function* editReminderSettings({ payload: { data, cb } }) {
  const url = `${API_BASE_URL}/reminders/${data.id}`;

  const response = yield request({
    method: 'put',
    data,
    url,
  });

  if (response.success) {
    yield put(editReminderSuccess(response.raw));
    Notify('Reminder updated successfully', {
      position: 'top-right',
      status: 'success',
    });
    if (cb && typeof cb === 'function') {
      cb();
    }
  } else {
    networkErrorHandler(response?.statusCode, `Failed to update Reminder: ${response.message}`);
    yield put(editReminderFailed(response.message));
  }
}

export function* edittingReminderSettings() {
  yield takeEvery(ReminderTypes.EDITING_REMINDER_SETTINGS, editReminderSettings);
}

// deleting reminder
export function* delReminderSettings({ payload: { id, cb } }) {
  const url = `${API_BASE_URL}/reminders/${id}`;

  const response = yield request({
    method: 'delete',
    url,
  });
  
  if (response.success) {
    yield put(deleteReminderSuccess(id));
    cb();
    Notify('Reminder deleted successfully', {
      position: 'top-right',
      status: 'success',
    });
  } else {
    networkErrorHandler(response?.statusCode, `Failed to delete Reminder: ${response.message}`);
    yield put(deleteReminderFailed(response.message));
  }
}

export function* deletingReminderSettings() {
  yield takeEvery(ReminderTypes.DELETING_REMINDER_SETTINGS, delReminderSettings);
}